import { ConfigStore } from "@/shared/model/store";

function transliterate(text) {
        const cyrillicToLatin = {
            'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd',
            'е': 'e', 'ё': 'yo', 'ж': 'zh', 'з': 'z', 'и': 'i',
            'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
            'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't',
            'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch',
            'ш': 'sh', 'щ': 'shch', 'ъ': '', 'ы': 'y', 'ь': '',
            'э': 'e', 'ю': 'yu', 'я': 'ya'
        };

        let transliterated = '';
        for (let i = 0; i < text.length; i++) {
            const char = text[i].toLowerCase();
            if (cyrillicToLatin[char]) {
                transliterated += cyrillicToLatin[char];
            } else {
                transliterated += text[i];
            }
        }
        return transliterated;
    }
export const saveFileToOPFS = async (file: File): Promise<string> => {
  const root = await navigator.storage.getDirectory();
  const fileName = file.name.replace(/\s+/g, '_');
  const fileHandle = await root.getFileHandle(fileName, { create: true });
  const writable = await fileHandle.createWritable();
  await writable.write(file);
  await writable.close();
  return fileName;
};

export const getFileFromOPFS = async (fileName: string): Promise<File> => {
  const root = await navigator.storage.getDirectory();
  const fileHandle = await root.getFileHandle(fileName);
  return await fileHandle.getFile();
};

export const listFilesInOPFS = async (): Promise<string[]> => {
  const root = await navigator.storage.getDirectory();
  const files: string[] = [];
  for await (const [name] of root.entries()) {
    files.push(name);
  }
  return files;
};

export const removeFileFromOPFS = async (fileName: string): Promise<void> => {
  const root = await navigator.storage.getDirectory();
  await root.removeEntry(fileName);
};

export const saveFile =
    async (file: File, fileName?: string): Promise<string> => {

      const name = fileName || file.name.replace(/\s+/g, '_')
      const root = await navigator.storage.getDirectory()
      const fileHandle = await root.getFileHandle(name, { create: true })
      const writable = await fileHandle.createWritable()
      await writable.write(file)
      await writable.close()

      return name
}


export const getDirectory = 
    async (folderPath: string): Promise<FileSystemDirectoryHandle> => {

      const root = await navigator.storage.getDirectory()
      const pathSegments = folderPath.split('/').filter(Boolean)

      let currentDir = root
      for (const segment of pathSegments) {
        currentDir = await currentDir.getDirectoryHandle(segment, { create: true })
      }

      return currentDir
    }

export const saveFileToFolder = 
    async (folderPath: string, file: File, fileName?: string): Promise<string> => {
      const dirHandle = await getDirectory(folderPath)
      let name = fileName || file.name.replace(/\s+/g, '_')
      name = transliterate(name)
      const fileHandle = await dirHandle.getFileHandle(name, { create: true })
      const writable = await fileHandle.createWritable()
      await writable.write(file)
      await writable.close()

      const fullPath = `${folderPath}/${name}`
      return fullPath
}

export const deleteFolder = 
    async (folderPath: string): Promise<void> => {
      const root = await navigator.storage.getDirectory()
      const pathSegments = folderPath.split('/').filter(Boolean)

      if (pathSegments.length === 0) return

      let parentDir = root
      for (let i = 0; i < pathSegments.length - 1; i++) {
        parentDir = await parentDir.getDirectoryHandle(pathSegments[i])
      }

      await parentDir.removeEntry(pathSegments[pathSegments.length - 1], {
        recursive: true
      })
}

export const getFileFromFolder =
    async (filePath: string): Promise<File | null> => {
      try {
        const [folderPath, fileName] = filePath
        .split('/')
        .filter(Boolean)
        .reduce(
          (acc, part, i, arr) => (i === arr.length - 1 ? [acc[0], part] : [acc[0] ? `${acc[0]}/${part}` : part, '']),
          ['', '']
        )

      const dirHandle = await getDirectory(folderPath)
      const fileHandle = await dirHandle.getFileHandle(fileName)
       return fileHandle.getFile()
      } catch (error) {
       return null
      } 
      
     
}

export const getFilesFromDirectory = async (folderName: string): Promise<[]> => {
  try{
  const root = await navigator.storage.getDirectory()
  const segments = folderName.split('/').filter(Boolean);
  const dirPath = segments.join('/');
  const folderHandle = await root.getDirectoryHandle(segments[0], { create: false })
  const uploadsHandler = await folderHandle.getDirectoryHandle('uploads', { create: false })
  const fileList = []
				for await (const entry of uploadsHandler.values()) {
					// 4. Фильтруем только файлы (исключаем папки)
					if (entry.kind === 'file') {
						fileList.push({ name: entry.name, full: `${dirPath}/${entry.name}` })
					}
				}
    return fileList
  } catch {
    return []
  }
  
};

export const deleteDirectory = async (
  path: string,
  recursive = true
): Promise<void> => {
  const segments = path.split('/').filter(Boolean);
  
  if (segments.length === 0) {
    throw new Error('Cannot delete root directory');
  }
  
  const root = await navigator.storage.getDirectory();
  let parentDir = root;
  
  // Переходим к родительской директории
  for (let i = 0; i < segments.length - 1; i++) {
    parentDir = await parentDir.getDirectoryHandle(segments[i]);
  }
  
  // Удаляем последний сегмент пути
  await parentDir.removeEntry(segments[segments.length - 1], { recursive });
};

export const deleteFileByPath = async (filePath: string): Promise<void> => {
		if (!('storage' in navigator && 'getDirectory' in navigator.storage)) {
			throw new Error('OPFS not supported in this browser')
		}

		// Разбиваем путь на сегменты
		const segments = filePath.split('/').filter(Boolean)

		// Если путь пустой
		if (segments.length === 0) {
			throw new Error('Invalid file path')
		}

		// Получаем корневой каталог
		const root = await navigator.storage.getDirectory()
		let currentDir = root

		// Переходим по всем сегментам пути, кроме последнего
		for (let i = 0; i < segments.length - 1; i++) {
			currentDir = await currentDir.getDirectoryHandle(segments[i])
		}

		// Последний сегмент - имя файла
		const fileName = segments[segments.length - 1]

		// Удаляем файл
		await currentDir.removeEntry(fileName)

		// Для рекурсивного обновления списка файлов (если используется)
	}

  export const OPFSUpload = async (rootDir: string = '') => {
	const { domain } = ConfigStore.getState()
	const root = await navigator.storage.getDirectory()
	const segments = rootDir.split('/').filter(Boolean)
	const folderHandle = await root.getDirectoryHandle(segments[0], { create: false })
	const allFiles: { path: string; file: File }[] = []

	// Рекурсивная функция для сбора файлов
	const collectFiles = async (dirHandle: FileSystemDirectoryHandle, currentPath = '') => {
		for await (const [name, handle] of dirHandle.entries()) {
			const entryPath = currentPath ? `${currentPath}/${name}` : name

			if (handle.kind === 'file') {
				const file = await handle.getFile()
				allFiles.push({ path: entryPath, file })
			} else if (handle.kind === 'directory') {
				await collectFiles(handle, entryPath)
			}
		}
	}

	await collectFiles(rootDir ? folderHandle : root)
	const formData = new FormData()
	const files = allFiles

	for (const { path, file } of files) {
		// Используем путь как имя файла в FormData
		if (!['tmp.json', 'reg_data.json'].includes(file.name)) {
			formData.append('file', file, path)
		}
	}
	formData.append('domain', domain)

	return formData
}


